module.exports = __webpack_public_path__ + "img/ALTS_logo_kz.bd6595e0.png";